import { Client } from '../../types/Client';
import { apiSlice } from '../apiSlice';

const endpointUrl = '/clients';

export const initialState: Client = {
  id: '',
  description: '',
  clientFormId: undefined,
  clientCandidateId: undefined,
  enabled: true
};

function getClients() {
  return `${endpointUrl}`;
}

function getClient({ id }: { id: string }) {
  return `${endpointUrl}/${id}`;
}

function updateEnabled({ id, enabled }: { id: string; enabled: boolean }) {
  return {
    url: `${endpointUrl}/${id}/enabled`,
    method: 'PATCH',
    body: { enabled }
  };
}

function createClient({
  description,
  clientFormId,
  clientCandidateId,
  enabled
}: {
  description: string;
  clientFormId?: string;
  clientCandidateId?: string;
  enabled: boolean;
}) {
  return {
    url: `${endpointUrl}`,
    method: 'POST',
    body: {
      description,
      clientFormId,
      clientCandidateId,
      enabled
    }
  };
}

function updateClient({
  id,
  description,
  clientFormId,
  clientCandidateId,
  enabled
}: {
  id: string;
  description: string;
  clientFormId?: string;
  clientCandidateId?: string;
  enabled: boolean;
}) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'PUT',
    body: { description, clientFormId, clientCandidateId, enabled }
  };
}

function deleteClient({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}

export const clientApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getAllClients: query<Client[], void>({
      query: getClients,
      providesTags: ['Clients']
    }),
    getClient: query<Client, { id: string }>({
      query: getClient,
      providesTags: ['Clients']
    }),
    updateClient: mutation<
      void,
      {
        id: string;
        description: string;
        clientFormId?: string;
        clientCandidateId?: string;
        enabled: boolean;
      }
    >({
      query: updateClient,
      invalidatesTags: ['Clients']
    }),
    updateEnabled: mutation<void, { id: string; enabled: boolean }>({
      query: updateEnabled,
      invalidatesTags: ['Clients']
    }),
    deleteClient: mutation<void, { id: string }>({
      query: deleteClient,
      invalidatesTags: ['Clients']
    }),
    createClient: mutation<
      void,
      {
        description: string;
        clientFormId?: string;
        clientCandidateId?: string;
        enabled: boolean;
      }
    >({
      query: createClient,
      invalidatesTags: ['Clients']
    })
  })
});

export const {
  useGetAllClientsQuery,
  useGetClientQuery,
  useUpdateEnabledMutation,
  useDeleteClientMutation,
  useUpdateClientMutation,
  useCreateClientMutation
} = clientApiSlice;

export default clientApiSlice; 